import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils"

const { Option } = Select;

const StructuralDamageForm = props => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [componentTypes, setComponentTypes] = useState([]);
    const [levelTypes, setLevelTypes] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data1 = await axios
                    .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/structural-components");
                setComponentTypes(data1.data);
                
                const data2 = await axios
                    .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/structural-damage-levels");
                setLevelTypes(data2.data);

                form.setFieldsValue({
                    structuralComponent: props.record.damage.structuralComponent,
                    structuralLevel: props.record.damage.structuralLevel,
                    extension: props.record.damage.extension,
                    description: props.record.damage.description,
                });
            } catch (error) {
                console.log(error);
            };
        }
        fetchData();
    }, [props.record.asset, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        const newAsset = { ...props.record };
        newAsset.damage.structuralComponent = elvis(allValues.structuralComponent);
        newAsset.damage.structuralLevel = elvis(allValues.structuralLevel);
        newAsset.damage.extension = elvis(allValues.extension);
        newAsset.damage.damageClass = props.damageClass;
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newAsset.valid = true;
                props.parentCallback(newAsset);
            })
            .catch(() => {
                newAsset.valid = false;
                props.parentCallback(newAsset);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="structuralComponent"
        >
            <Form.Item
                label="Classification"
                name="structuralComponent"
                tooltip="Classification"
            >
                <Select>
                    {componentTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('buildingEnums.structuralComponent.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            
            <Form.Item
                label="Damage level"
                name="structuralLevel"
                tooltip="Damage level"
            >
                <Select>
                    {levelTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('buildingEnums.structuralDamageLevel.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            
            <Form.Item label="Damage extension (%)" name="extension">
                <InputNumber />
            </Form.Item>
        </Form>
    );
};

export default StructuralDamageForm;